/* eslint-disable import/prefer-default-export */
export enum UploadStatus {
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  COMPLETED = 'completed'
}
